import React, { useCallback, useEffect, useState } from 'react';
import classNames from 'classnames';
import { useToastContext } from './ToastContext';

export const Toast = ({
  isShown,
  animationKey,
  children,
  className = 'p-4',
}) => {
  const [isDisplayed, setDisplayed] = useState(isShown);
  const [animationState, setAnimation] = useState(null);

  useEffect(() => {
    if (isShown && !isDisplayed) {
      setDisplayed(true);
      setAnimation('fade-in');
    } else if (!isShown && isDisplayed) {
      setDisplayed(false);
      setAnimation('fade-out')
    }
  }, [isDisplayed, isShown])

  const onAnimationEnd = useCallback(() => {
    if (animationState === 'fade-out') {
      setDisplayed(false);
    }
    setAnimation(null);
  }, [animationState])

  return (
    <div className="z-50 px-96 fixed inset-x-0 bottom-0">
      <div
        key={animationKey}
        className={classNames(
          className,
          'mb-4 text-center text-brand text-lg rounded bg-toast-background border-2 border-toast-border',
          { [`animate-${animationState}`]: animationState },
          { 'hidden': !isDisplayed },
        )}
        onAnimationEnd={onAnimationEnd}
      >
        { children }
      </div>
    </div>
  )
};

const WrappedToast = () => {
  const { isShown, toastText } = useToastContext()
  return (
    <Toast
      animationKey="app-toast"
      isShown={isShown}
    >
      { toastText }
    </Toast>
  )
}

export default WrappedToast;
